module.exports = __webpack_public_path__ + "img/ft2.874b792a.png";